module.exports = __webpack_public_path__ + "static/assets/b6749a2b902e8801163c71b7d344f019.png";